import React from 'react';

const localSeoItems = [
  {
    title: 'Google Business Profile:',
    desc: 'Local SEO helps businesses get local area results.'
  },
  {
    title: 'Listing:',
    desc: 'Improves the online presence of a business on local searches'
  },
  {
    title: 'Directory:',
    desc: 'Helps generate local traffic and engagement.'
  },
  {
    title: 'Info:',
    desc: 'Provide the correct business name, address, and phone number (NAP). Also include business hours, photos, and customer reviews.'
  },
  {
    title: 'Local Citations:',
    desc: 'Consistent NAP information across online directories.'
  },
  {
    title: 'Reviews',
    desc: 'Encourage customers to leave online reviews on Google and other relevant platforms.'
  },

];

function LocalSeoScrollSection() {
  return (
    <section className="local-seo-scroll-section">
      <div className="container local-seo-container">
        {/* Left Column: Scrollable Local SEO Content */}
        <div className="local-seo-left">
          <h2 className="local-seo-title">Local SEO</h2>

          <div className="local-seo-scroll-box">
            {localSeoItems.map((item, index) => (
              <div key={index} className="local-seo-item">
                <h3 className="local-seo-item-title">{item.title}</h3>
                <p className="local-seo-item-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column: Image Showcase */}
        <div className="local-seo-right">
          <div className="local-seo-img-wrapper">
            <img
              src="/assets/images/seo-services/seo-img2.jpg"
              alt="Local SEO Services and Google Business Optimization"
              className="local-seo-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default LocalSeoScrollSection;
